/**
 * Обложка модели для витрины: JPEG не больше 1000 × 750, до ~500 КБ.
 * Источник — файл сотрудника или рендер визуализатора (замечание № 29).
 */
export async function prepareCover(image: Blob, fromFile = true) {
  if (fromFile && (!["image/jpeg", "image/png", "image/webp"].includes(image.type) || image.size > 8 * 1024 * 1024)) {
    throw new Error("Выберите JPG, PNG или WebP до 8 МБ");
  }
  const bitmap = await createImageBitmap(image);
  try {
    if (bitmap.width > 12000 || bitmap.height > 12000) throw new Error("Обложка слишком большая по разрешению");
    const factor = Math.min(1, 1000 / bitmap.width, 750 / bitmap.height);
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bitmap.width * factor)); canvas.height = Math.max(1, Math.round(bitmap.height * factor));
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Не удалось подготовить обложку");
    context.fillStyle = "#faf7f2"; context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    // Рендер детальный: если не влез, сжимаем сильнее, а не отказываем.
    for (const quality of [0.82, 0.72, 0.62]) {
      const data = canvas.toDataURL("image/jpeg", quality);
      if (data.length <= 660000) return data;
    }
    throw new Error("Обложка слишком детальная. Выберите изображение меньшего размера");
  } finally { bitmap.close(); }
}
